export function buildFocusGroupListTableHeaders({ t }) {
  return [
    {
      value: "id",
      text: t("focusGroup.id"),
      thClass: "w-24",
      tdClass: "max-w-[2rem] min-w-[5rem]",
      disabled: true,
    },
    {
      value: "name",
      text: t("focusGroup.name"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[9rem] min-w-[7rem]",
    },
    {
      value: "customers",
      text: t("focusGroup.customers"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[9rem] min-w-[7rem]",
    },
    {
      value: "isActive",
      text: t("focusGroup.isActive._"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[9rem] min-w-[7rem]",
    },
  ];
}
